import React from 'react';

class ChatScript extends React.Component {
 
    render() {
        let script = this.props.script;

        if (script)
        {
            $('body').append(script);
        }
        
        return (
            <div
                id={this.props.embeddedWebChatId}
                className={this.props.className}
            />
        );
    }
}

export default ChatScript;  